import React from 'react';
import { useSelector, useDispatch } from 'react-redux';

// import selectors
import { getTranslationById } from 'js/store/app/App.selectors';

// import components
import AccordionBase from 'js/components/accordion/Accordion.base';

// import actions
import { updateActivityFilter, resetFilters } from 'js/store/search/Search.actions';
import { trackEvent } from '../../../utils/tracking';

const FindStep1 = ({ setCurrentStep }) => {
  // site text
  const title = useSelector((state) => getTranslationById(state, 'find_step_1_title', 'What do you want to do?'));
  const option1Text = {
    title: useSelector((state) => getTranslationById(state, 'find_step_1_time_to_transition', 'Time to Transition')),
    content: useSelector((state) =>
      getTranslationById(
        state,
        'find_step_1_time_to_transition_info',
        'Supports one of the hardest parts of the day with quick, structured choices.'
      )
    ),
  };
  const option2Text = {
    title: useSelector((state) => getTranslationById(state, 'find_step_1_lets_get_moving', "Let's Get Moving")),
    content: useSelector((state) =>
      getTranslationById(
        state,
        'find_step_1_lets_get_moving_info',
        'Burns off energy with quick, playful activities that get bodies active and minds engaged.'
      )
    ),
  };
  const option3Text = {
    title: useSelector((state) => getTranslationById(state, 'find_step_1_calm_and_collected', 'Calm and Collected')),
    content: useSelector((state) =>
      getTranslationById(
        state,
        'find_step_1_calm_and_collected_info',
        'Brings the moment back to centre with simple, soothing activities that help children reset and refocus.'
      )
    ),
  };

  const dispatch = useDispatch();

  React.useEffect(() => {
    dispatch(resetFilters());
  }, []);

  const data = [
    {
      title: option1Text.title,
      content: option1Text.content,
      id: 'activity_1',
      action: () => {
        trackEvent('game_find_ttt_click');
        dispatch(updateActivityFilter('activity_1'));
      },
    },
    {
      title: option2Text.title,
      content: option2Text.content,
      id: 'activity_2',
      action: () => {
        trackEvent('game_find_lgm_click');
        dispatch(updateActivityFilter('activity_2'));
      },
    },
    {
      title: option3Text.title,
      content: option3Text.content,
      id: 'activity_3',
      action: () => {
        trackEvent('game_find_cac_click');
        dispatch(updateActivityFilter('activity_3'));
      },
    },
  ];

  return (
    <div className="find__step-1">
      <div className="h1-container">
        <h1 className="find__title find__step-1-title">{title}</h1>
      </div>
      <AccordionBase data={data} callback={setCurrentStep} />
    </div>
  );
};

export default FindStep1;
